import React from 'react';
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {HeaderWelcomeButtonsForAuthorizedUserMobileViewComponent} from "./mobile-view/header-welcome-buttons-for-authorized-user-mobile-view.component";
import {HeaderWelcomeButtonsForAuthorizedUserPcViewComponent} from "./pc-view/header-welcome-buttons-for-authorized-user-pc-view.component";

@observer
export class HeaderWelcomeButtonsForAuthorizedUserComponent extends OrbitComponent {
    render() {
        if(this.services.mediaQuery.lAndBelow) {
            return (<HeaderWelcomeButtonsForAuthorizedUserMobileViewComponent/>);
        } else {
            return (<HeaderWelcomeButtonsForAuthorizedUserPcViewComponent/>);
        }

    }
}